import { render, staticRenderFns } from "./text-password-reset-link-dialog.vue?vue&type=template&id=8d935026&scoped=true&"
import script from "./text-password-reset-link-dialog.vue?vue&type=script&lang=js&"
export * from "./text-password-reset-link-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d935026",
  null
  
)

export default component.exports